import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BusinessCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"business_center"}/>
}
